import { getChildWidgetStyle, handleWidgetUpdate } from '@juvare/common-form-ui/WidgetForm/Utils';
import { WidgetComponent } from '@juvare/widget-ui/WidgetComponent';
import { Box } from '@mui/material';
import React from 'react';
const type = 'alert.customLayout';
const WidgetCustomLayout = (props) => {
    return (React.createElement(Box, { sx: props.config.rootSx }, props.childProps &&
        props.childProps.map((childProp, index) => {
            var _a;
            return (React.createElement(Box, { key: childProp.id, sx: (_a = props.config.childrenSx) === null || _a === void 0 ? void 0 : _a[index], style: getChildWidgetStyle(childProp) }, childProp.hidden ? undefined : React.createElement(WidgetComponent, Object.assign({}, childProp))));
        })));
};
export const widgetCustomLayout = {
    type,
    validate: (props) => { var _a; return (((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.errorInChild) ? 'One of child component has error.' : undefined); },
    update: (props) => handleWidgetUpdate(props),
    childConfigs: (config) => config.children,
    component: WidgetCustomLayout,
};
